import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { getToken, getUserInfo } from './authentication';
//import Cookies from 'universal-cookie';

export const AuthContext = React.createContext({});

const Auth = ({ children }) => {

    const checkIsAuthenticated = () => {
        // Double-check:  Check we've got a secure cookie AND check session storage for isAuthenticated flag
        const isAuthenticated = sessionStorage.getItem('isAuthenticated');
        //const cookies = new Cookies();
        //const csrf = cookies.get('CSRF');
        // We don't check whether the CSRF is valid or not, just that we've got one.
        //return (!!csrf) && isAuthenticated;
        return isAuthenticated;
    };

    const userInfo = () => {
        const info = sessionStorage.getItem('userInfo');
        return info ? JSON.parse(info) : null;
    };

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const authenticateUser = async (urlParams) => {
        let userAuthenticated = false;
        let userInformation = null;
        const token = await getToken(urlParams);
        console.log('authenticateUser token', token);
        if (token) {
            const tokenUserInfo = await getUserInfo();
            if (tokenUserInfo) {
                userInformation = tokenUserInfo;
                userAuthenticated = true;
            }
        }
        sessionStorage.setItem('userInfo', userInformation ? JSON.stringify(userInformation) : null);
        sessionStorage.setItem('isAuthenticated', userAuthenticated);
        return userAuthenticated;
    };

    return (
        <AuthContext.Provider value={ { checkIsAuthenticated, authenticateUser, userInfo } }>
            { children }
        </AuthContext.Provider>
    );
}

Auth.propTypes = {
    children: PropTypes.node.isRequired
};

export default memo(Auth);
